import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import commoncss from "../../css/common.module.css";
import FixedAssetSideBar from "../../components/fixedasset/FixedAssetSideBar";
import FaRegHeader from "../../fixedassetelements/Headers/FaHeaders";
import DataState from "../../fixedassetelements/common/DataState/DataState";
import ERPTable from "../../fixedassetelements/table/ERPTable";
import FixedAssetTable from "../../fixedassetelements/table/FixedAssetsTable";

const FixedAssetListing = () => {
  const [showDataState, setShowDataState] = useState(true);
  const [tableType, setTableType] = useState(null);
  const [showTable, setShowTable] = useState(false);
  const [appliedFilters, setAppliedFilters] = useState([]);
  const [showAddRegisterModal, setShowAddRegisterModal] = useState(false);
  const { id: routeFixedAssetID } = useParams();
  const [fixedAssetID, setFixedAssetID] = useState("");

  useEffect(() => {
    if (routeFixedAssetID) {
      setFixedAssetID(routeFixedAssetID);
      const savedTableType = sessionStorage.getItem(`tableType_${routeFixedAssetID}`);
      if (savedTableType) {
        setTableType(savedTableType);
        setShowTable(true);
        setShowDataState(false);
      }
    }
  }, [routeFixedAssetID]);

  useEffect(() => {
    if (showTable && tableType === null) {
      const savedTableType = fixedAssetID
        ? sessionStorage.getItem(`tableType_${fixedAssetID}`)
        : null;
      setTableType(savedTableType || "excel");
    }
  }, [showTable, tableType, fixedAssetID]);

  const handleFiltersApplied = (filters) => {
    setAppliedFilters(filters);
  };

  const handleNoDataFound = () => {
    setAppliedFilters([]);
  };

    return (
    <div style={{ display: "flex" }}>
      <FixedAssetSideBar activeTab={"Listing"} fixedAssetID={fixedAssetID} />

      <div className={`${commoncss.widthScrHidden} px-3 py-2`}>
        <FaRegHeader
          fixedAssetID={fixedAssetID}
          setFixedAssetID={setFixedAssetID}
          setShowDataState={setShowDataState}
          tableType={tableType}
          setTableType={setTableType}
          setShowTable={setShowTable}
          appliedFilters={appliedFilters}
          onFiltersApplied={handleFiltersApplied}
          showAddRegisterModal={showAddRegisterModal}
          setShowAddRegisterModal={setShowAddRegisterModal}
        />

        {showDataState && !showTable && <DataState  setShowAddRegisterModal={setShowAddRegisterModal} />}

        {showTable && tableType === "excel" && (
          <FixedAssetTable
            FixedAssetID={fixedAssetID}
            filters={appliedFilters}
            onNoDataFound={handleNoDataFound}
          />
        )}
        {showTable && tableType === "erp" && <ERPTable FixedAssetID={fixedAssetID} />}
      </div>
    </div>
  );
};

export default FixedAssetListing;
